module.exports = __webpack_public_path__ + "img/i2.6d1d42bd.jpg";